import React from 'react';
import { formatStringAsCurrency } from '../../../Utils/stringUtils';
import ResultValue from '../../Simple/ResultValue';

export default function NonPPSPricing(props) {
    return (<>
        <ResultValue label="Critical Access Hospital Payment" value={formatStringAsCurrency(props.result.criticalAccessHospitalPayment)} />
        <ResultValue label="Maryland Waiver Hospital Payment" value={formatStringAsCurrency(props.result.marylandWaiverProviderPayment)} />
        <ResultValue label="Maryland GME Reduction" value={formatStringAsCurrency(props.result.marylandGMEReduction) || props.result.marylandGMEReduction} />
    </>);
}